import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetSubmittedReports } from '@/query/queries/reporting/useGetSubmittedReports';
import { Pagination } from '@/components/Pagination';
import { ReportingCard } from '../card';
import s from './index.module.scss';

export const SubmittedDocuments = () => {
  const [page, setPage] = useState(1);
  const { data: reports } = useGetSubmittedReports({ page });
  const { t } = useTranslation('reporting');

  if (!reports?.list.length) return null;

  return (
    <div className={s.wrapper}>
      <div className="f-body-regular">{t('reporting_page.submitted_docs')}</div>
      <div className={s.reports}>
        {reports.list.map(report => (
          <ReportingCard key={report.id} report={report} />
        ))}
        {reports?.total_pages > 0 && (
          <Pagination
            currentPage={page - 1}
            totalPages={reports?.total_pages}
            onPageChange={({ selected }) => setPage(selected + 1)}
          />
        )}
      </div>
    </div>
  );
};
